import {defineStore} from 'pinia'
import RequestMixin from "controllers/vue_components/mixins/request"

export const useCalendarStore = defineStore('calendar_store', {
    state: () => {
        return {
            host_events: [], // Array of events appearing on https://timelydo.com/events
            calendar_settings: {},
            events: [],
            selected_event: 'all_events',
            views_list: [],
            days_list: [],
            calendars_list: [],
            connectionStatus: 'disconnected', // 'connected' | 'disconnected' | 'rejected'
        }
    },

    actions: {
        setCalendarSettings(calendarSettings) {
            this.calendar_settings = calendarSettings
        },
        setViewsList(list) {
            this.views_list = list
        },
        setConnectionStatus(status) {
            this.connectionStatus = status
        },
        addBooking(booking) {
            const exists = this.events.some(e => e.id === booking.id)
            if (!exists) {
                this.events.push(booking)
            }
        },
        updateBooking(booking) {
            const idx = this.events.findIndex(e => e.id === booking.id)
            if (idx !== -1) {
                this.events.splice(idx, 1, booking)
            }
        },
        removeBooking(bookingId) {
            this.events = this.events.filter(e => e.id !== bookingId)
        },
    },
})